export const FIGMA_BASE_URL: string = import.meta.env.VITE_FIGMA_BASE_URL;

/**
 * Deep link to a node in a Figma design file, on the current environment's Figma origin
 * (staging vs prod). Figma URLs use the dash form of node ids (`40001338-118510`), not the colon form.
 * `fileName` is an optional path slug for a human-readable URL (Figma resolves by `fileKey` regardless).
 */
export function buildFigmaDesignUrl(fileKey: string, nodeId: string, fileName?: string): string {
  const slug = fileName
    ?.trim()
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const path = slug ? `/design/${fileKey}/${slug}` : `/design/${fileKey}`;
  return `${FIGMA_BASE_URL}${path}?node-id=${nodeId.replace(/:/g, '-')}`;
}
